module.exports = __webpack_public_path__ + "img/eop.36c8f660.svg";